import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const YM_ID = process.env.REACT_APP_YANDEX_METRIKA_ID;

export const Metrika = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (YM_ID) {
      const url = pathname + search;

      // eslint-disable-next-line no-undef
      ym(YM_ID, "hit", url);
    }
  }, [pathname, search]);

  return null;
};
